import type { TGetListaDeClientesParams } from '@/shared/interfaces/cliente.types'

import type { TGetLeadsRepresadosParams } from '../services/get-leads-represados.service'

export const clienteKeys = {
  cliente: ['cliente'] as const,
  lista: () => [...clienteKeys.cliente, 'lista'] as const,
  atualizar: () => [...clienteKeys.cliente, 'atualizar'] as const,
}
export const listarClientesKeys = {
  cliente: ['clientes'] as const,
  lista: () => [...listarClientesKeys.cliente, 'lista'] as const,
}

export const atualizarClienteKeys = {
  cliente: ['clientes-atualizar'] as const,
  atualizar: () => [...atualizarClienteKeys.cliente, 'atualizar'] as const,
}

export const cadastrarClienteKeys = {
  cliente: ['clientes-cadastrar'] as const,
  cadastrar: () => [...cadastrarClienteKeys.cliente, 'cadastrar'] as const,
}

export const clienteConflitosKeys = {
  cliente: ['clientes-conflitos'] as const,
  conflitos: () => [...clienteConflitosKeys.cliente, 'conflitos'] as const,
}

export const clientePorCpfPropostaKeys = {
  cliente: ['clientes-cpf-proposta'] as const,
  obter: (cpf: string) => [...clientePorCpfPropostaKeys.cliente, cpf],
}

export const nacionalidadeClienteKeys = {
  nacionalidade: ['clientes-nacionalidade'] as const,
  lista: () => [...nacionalidadeClienteKeys.nacionalidade, 'lista'] as const,
}

export const profissaoClienteKeys = {
  profissao: ['clientes-profissao'] as const,
  lista: () => [...profissaoClienteKeys.profissao, 'lista'] as const,
}
export const clientesKeys = {
  cliente: ['clientes'] as const,
  lista: (query: TGetListaDeClientesParams, t: string) => [...clientesKeys.cliente, 'lista', query, t] as const,
  conflitos: (query: TGetListaDeClientesParams) => [...clientesKeys.cliente, 'conflitos', query] as const,
  leadsRepresados: (query: TGetLeadsRepresadosParams) => [...clientesKeys.cliente, 'leadsRepresados', query] as const,
  leadRepresadoPorId: (id: string) => [...clientesKeys.cliente, 'leadRepresado', id] as const,
  documentosLeadRepresado: (clienteId: string) =>
    [...clientesKeys.cliente, 'documentosLeadRepresado', clienteId] as const,
}
